module.exports = __webpack_public_path__ + "img/ryzs15.6bc1aad6.jpg";